import * as ReactGA from 'react-ga';

ReactGA.initialize('G-LG20HJZ1C5');
ReactGA.pageview(location.pathname + location.search);
